import Vue from 'vue'
import Router from 'vue-router'


import index from '@/views/index'
import home from '@/views/home/home'
import main from '@/views/main/main'
import main_money from '@/views/main/main_money'
import main_news from '@/views/main/main_news'
import main_record from '@/views/main/main_record'
import about from '@/views/about/about'
import honor from '@/views/honor/honor'
import product from '@/views/product/product'
import productDetail from '@/views/product/productDetail'
import partner from '@/views/partner/partner'
import news from '@/views/news/news'
import newsDetail from '@/views/news/newsDetail'
import contact from '@/views/contact/contact'
import announcement from '@/views/announcement/announcement'
import bidding from '@/views/bidding/bidding'
import biddingDetail from '@/views/bidding/biddingDetail'
import register from '@/views/register/register'
import clause from '@/views/register/clause'
import announcementDetail from '@/views/announcement/announcementDetail'
import login from '@/views/login/login'
import forget from '@/views/forget/forget'
Vue.use(Router)


export default new Router({
	// mode: 'history',
	routes: [{
			path: '/',
			name: 'index',
			component: index,
			children: [{
					path: "/home",
					name: 'home',
					component: home
				}, //首页
			],
		},
		{
			path: "/announcementDetail",
			name: 'announcementDetail',
			component: announcementDetail
		}, //公告
		{
			path: "/announcement",
			name: 'announcement',
			component: announcement
		}, //公告
					
		{
			path: "/contact",
			name: 'contact',
			component: contact
		}, //联系我们
		{
			path: "/newsDetail",
			name: 'newsDetail',
			component: newsDetail
		}, //新闻详情
		{
			path: "/news",
			name: 'news',
			component: news
		}, //新闻
		{
			path: "/partner",
			name: 'partner',
			component: partner
		}, //合作伙伴
		{
			path: "/biddingDetail",
			name: 'biddingDetail',
			component: biddingDetail
		}, //招标信息详情
		{
			path: "/bidding",
			name: 'bidding',
			component: bidding
		}, //招标信息
		{
			path: "/productDetail",
			name: 'productDetail',
			component: productDetail
		}, //主营产品详情
		{
			path: "/product",
			name: 'product',
			component: product
		}, //主营产品
		{
			path: "/honor",
			name: 'honor',
			component: honor
		}, //资质
		{
			path: "/about",
			name: 'about',
			component: about
		}, //关于我们
		{
			path: "/main",
			name: 'main',
			component: main
		}, //个人中心
		{
			path: "/main_money",
			name: 'main_money',
			component: main_money
		}, //余额
		{
			path: "/main_record",
			name: 'main_record',
			component: main_record
		}, //竞拍记录
		{
			path: "/main_news",
			name: 'main_news',
			component: main_news
		}, //消息
		{
			path: "/register",
			name: 'register',
			component: register
		}, //注册
		{
			path: "/clause",
			name: 'clause',
			component: clause
		}, //注册条款
		{
			path: "/login",
			name: 'login',
			component: login
		}, //登录
		{
			path: "/forget",
			name: 'forget',
			component: forget
		}, //忘记密码
		{
			path: '*',
			name: '/404',
			component: resolve => require(['@/components/404.vue'], resolve),
		},
	]
})
//连续点击同一地址 报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js